import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
import React from "react";

const ReportsVehiclesDetailIdList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsVehiclesDetail/ReportsVehiclesDetailId/ReportsVehiclesDetailId"
    )
);
export const ReportsVehiclesDetailId = () => {
  return (
    <Layout>
      <ReportsVehiclesDetailIdList />
    </Layout>
  );
};
